import * as React from "react";
import styled from "styled-components";
import Text from "../../elements/Text";
import { select } from "@hubper/theme";
import { PageSubtitle } from "../../typo";

const Base = styled.div`
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  padding: ${select.space(3)} 0 0 ${select.space(3)};
  transition: ${select.speed("fast")};
  position: relative;

  &:not(:last-child) {
    .toggle-box-main {
      border-bottom: 1px solid ${select.color(["grey", 1])};
    }
  }

  &:hover {
    background-color: ${select.color(["grey", 0])};
  }
`;

const Main = styled.div`
  flex-grow: 1;
  padding-bottom: ${select.space(3)};
  padding-right: 40px;
`;

const Image = styled.div`
  width: 56px;
  height: 56px;
  margin-right: ${select.space(4)};
  background-color: ${select.color(["grey", 0])};
  border-radius: 5px;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  id: string;
  title: string;
  creator: string;
  nrOfEpisodes: number;
  imageUrl: string;
  onClick: (id: string) => void;
};

function PodcastSearchItem(
  {
    style,
    className,
    title,
    creator,
    imageUrl,
    id,
    nrOfEpisodes,
    onClick
  }: Props,
  ref: any
) {
  return (
    <Base
      ref={ref}
      style={style}
      className={className}
      onClick={() => onClick(id)}
    >
      <Image>{imageUrl && <img src={imageUrl} alt={title} />}</Image>
      <Main className="toggle-box-main">
        <Text c={["grey", 9]} fs={2} fw="bold" style={{ display: "block" }}>
          {title}
        </Text>
        <PageSubtitle>{creator}</PageSubtitle>
        <Text c={["grey", 5]} fs={-2} style={{ display: "block" }}>
          {nrOfEpisodes} episodes
        </Text>
      </Main>
    </Base>
  );
}

export default React.forwardRef(PodcastSearchItem);
